import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent {
  errorMessage: string = 'An unexpected error occurred.';

  constructor(
    private ref: DynamicDialogRef, 
    private config: DynamicDialogConfig
  ) {
    if (this.config.data && this.config.data.message) {
      this.errorMessage = this.config.data.message;
    }
  }

  close() {
    this.ref.close();
  }
}